import { createActions } from 'redux-actions';
import identity from 'ramda/src/identity';
import i18next from 'i18next';

const actionsDefinition = {
  SHOW_SNACKBAR: identity,
  CLOSE_SNACKBAR: () => undefined,
};

export const { showSnackbar, closeSnackbar } = createActions(actionsDefinition);

/**
 * Axios errors carry the whole request config — including the Authorization header — and
 * LogRocket (initialised in App.js) records console output verbatim, so logging one as-is
 * would ship the user's bearer token off-site. Reduce those to the fields that actually help
 * diagnose. Anything else (a plain Error, a TypeError thrown inside a thunk, ...) is passed
 * through untouched so its message and stack survive.
 */
export const describeError = (error) => {
  const { config, response } = error || {};
  if (!config && !response) return error;

  return {
    method: config?.method,
    url: config?.url,
    status: response?.status,
    message: response?.data?.message || error?.message,
  };
};

export const showGenericError = (error) => {
  if (error) {
    // eslint-disable-next-line no-console
    console.error('genericError:', describeError(error));
  }
  // Must RETURN the action: callers do dispatch(showGenericError()), and dispatching
  // undefined makes redux throw inside errorMiddleware's catch, which dispatches
  // showGenericError again — unbounded recursion (RangeError: max call stack).
  return showSnackbar({ message: i18next.t('global.genericError') });
};

export const getGenericSuccessMessage = () => i18next.t('global.forms.notification.save');

export const showGenericSuccess = () => showSnackbar({ message: getGenericSuccessMessage() });
